import React from 'react';
import ServiceHeader from '../components/ServiceHeader';
import MainServices from '../components/MainServices';
import ServiceFeatures from '../components/ServiceFeatures';
import FAQ from '../components/FAQ';

const Services: React.FC = () => {
  return (
    <div className="pt-20">
      <ServiceHeader />
      <MainServices />
      <ServiceFeatures />
      {/* <FAQ /> */}
    </div>
  );
};

export default Services; 